import { render, staticRenderFns } from "./DetailRoleAccessModal.vue?vue&type=template&id=d40201c0"
import script from "./DetailRoleAccessModal.vue?vue&type=script&lang=js"
export * from "./DetailRoleAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports